import { Button } from "@classdojo/web/nessie";
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { ReactNode } from "react";
import FullWidthButton from "./FullWidthButton";

type ButtonProps = {
  /**
   * The name will get used for automated product events.
   * @see https://www.notion.so/classdojo/Automatic-Product-Events-for-Web-bfc580f10a914c3ba514e5ec20f8ef9e?pvs=4
   */
  "data-name": string;
  text: string;
  onClick: VoidFunction;
};

type ToolkitModalProps = {
  children: ReactNode;
  primaryButton: ButtonProps;
  secondaryButton: ButtonProps;
};

export default function ToolkitModal({ children, primaryButton, secondaryButton }: ToolkitModalProps) {
  return (
    <div
      sx={{
        position: "absolute",
        top: 0,
        paddingTop: RAW_cssValue(100),
        backgroundColor: RAW_cssValue("rgba(66, 62, 93, 0.5)"),
        minHeight: "100vh",
        width: "100%",
        zIndex: 20,
      }}
    >
      <div
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "dt_background_primary",
          borderRadius: "dt_radius_m",
          height: 370,
          padding: "dt_s",
          position: "relative",
        }}
      >
        {children}
        <FullWidthButton
          text={primaryButton.text}
          onClick={primaryButton.onClick}
          data-name={primaryButton["data-name"]}
        />
        {secondaryButton && (
          <Button
            width={"80%"}
            kind="secondary"
            onClick={secondaryButton.onClick}
            data-name={secondaryButton["data-name"]}
          >
            {secondaryButton.text}
          </Button>
        )}
      </div>
    </div>
  );
}
